import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const treeVerseQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-wishlist-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch the Treeverse Combat Trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/treeverse/TreeverseCombatTrailer.mp4`,
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-trailer-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/endlessclouds",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-discord-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-discord",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Treeverse on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/TheTreeverse",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-twitter-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-twitter",
  },
];

const treeVerseQuestsLvl1VariantB: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-wishlist-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch the Treeverse Combat Trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/TreeverseCombatTrailer.mp4`,
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-trailer-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/endlessclouds",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-discord-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-discord",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Treeverse on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/TheTreeverse",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-twitter-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-twitter",
  },
];

const treeVerseQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Sign up for the newsletter",
    caption: "Stay up to date with the latest news",
    linkUrl: "https://endlessclouds.substack.com/",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-website-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-website-newsletter",
    waitTimeInHrs: 24,
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-onboarding-event",
    ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-onboarding",
  },
];

export const treeVerseQuestsVariantB: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      description: "Level 1 Supporter",
      title: "Learn and connect",
    },
    hideOnCompletion: true,
    nextQuest: {
      url: "/games/norma-in-metaland",
      title:
        "Thanks for following Treeverse. Keep showing your support and earn better perks while doing it.",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    totalGemsGranted: 30,
    quests: treeVerseQuestsLvl1VariantB,
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Experience more",
      description: "Level 2 Supporter",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn Gems",
    totalGemsGranted: 10,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: [
      {
        type: "link",
        key: "website",
        icon: "ApplicationWeb",
        label: "Sign up for the newsletter",
        caption: "Stay up to date with the latest news",
        linkUrl: "https://endlessclouds.substack.com/",
        increase: 10,
        badgeIcon: "ImxRewards",
        badgeTemplate: "+<increase> <icon> Gems",
        eventId: "6253fded-0d07-4e41-8239-e935f6f5748e-website-b-event",
        ruleId: "6253fded-0d07-4e41-8239-e935f6f5748e-website-b",
      },
    ],
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making Treeverse a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6LwQJbqstJ9-O9j_TV_Levels_2.png?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6LwQZbqstJ9-O9k_TV_Levels_3.png?auto=format,compress",
    },
  },
];

export const treeVerseQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +30 <icon> Gems",
    totalGemsGranted: 30,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: treeVerseQuestsLvl1,
    introModal: {
      title: "You're on your way to Level 1",
      description:
        "Thanks for following Treeverse. Keep showing your support and earn better perks while doing it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6LwP5bqstJ9-O9i_TV_Levels_1.png?auto=format,compress",
    },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Dive deeper",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +20 <icon> Gems",
    totalGemsGranted: 20,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: treeVerseQuestsLvl2,
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making Treeverse a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6LwQJbqstJ9-O9j_TV_Levels_2.png?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6LwQZbqstJ9-O9k_TV_Levels_3.png?auto=format,compress",
    },
  },
];
